import css from './index.module.scss';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import gtm from '@/utils/gtm';
import { configs } from './configs';

export default function AMZMemberDay() {
    const { includePages, includeSites, times, text, imgs } = configs;
    const { locale = 'us', pathname, query } = useRouter();
    const now = query?._timer ? new Date(query._timer + ' GMT+8').getTime() : new Date().getTime();
    const IS_ACTIVE = now >= new Date(times.start).getTime() && now < new Date(times.end).getTime();
    const i18n = text[locale] || text.us;

    useEffect(() => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_banner',
            banner_name: i18n.label + ' ' + i18n.title,
            position: 'activityBanner_1',
        });
    }, []);

    return (
        <>
            {includePages.includes(pathname) && includeSites.includes(locale) && IS_ACTIVE && (
                <div className={`${css['amz-activity']} amz-activity`}>
                    <EfImg pc={imgs[0]} h5={imgs[1]} />
                    <div className="info">
                        <p className="label">{i18n.label}</p>
                        <div className="content">
                            <p className="text">{i18n.text}</p>
                            <p className="title">{i18n.title}</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
